export default "__VITE_ASSET__Cly_TIVS__"